// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-container_root__doXpz"};